import React from 'react';
import styled from 'styled-components';

const StyledContent = styled.div`
  display: flex;
  justify-content: center;
`;

const StyledCard = styled.div`
  text-align: center;
`;

const StyledContentImg = styled.div<CardPhotoProps>`
  flex-shrink: 0;
  position: relative;
  width: 200px;
  height: 270px;
  background-color: #c1c1c1;
  background-image: url(${({ src }: any) => src || '/image/null-photo.png'});
  background-size: cover;
  background-position: center;

  &:before {
    content: '';
    position: absolute;
    left: -14px;
    top: 5%;
    background-color: ${({ theme }) => theme.colors.main};
    width: 15px;
    height: 40%;
  }
`;

type CardPhotoProps = {
  src?: string;
};

const CardPhoto = ({ src }: CardPhotoProps) => {
  return (
    <StyledContent>
      <StyledCard>
        <StyledContentImg src={src} />
      </StyledCard>
    </StyledContent>
  );
};

export default CardPhoto;
